import * as Sentry from "@sentry/react";
import { Links, Meta, Outlet, Scripts, ScrollRestoration, useRouteError } from "react-router";
import type { LinksFunction } from "react-router";

import "./tailwind.css";

export const links: LinksFunction = () => [
  { rel: "preconnect", href: "https://fonts.googleapis.com" },
  {
    rel: "preconnect",
    href: "https://fonts.gstatic.com",
    crossOrigin: "anonymous",
  },
  {
    rel: "stylesheet",
    href: "https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap",
  },
];

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    // https://stackoverflow.com/a/75339011
    (<html lang="en" suppressHydrationWarning={true}>
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <Meta />
        <Links />
        <script
          defer
          data-domain="app.read-type.com"
          src="https://plausible.dirathea.com/js/script.pageview-props.tagged-events.js"
        ></script>
      </head>
      <body>
        {children}
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>)
  );
}

export const ErrorBoundary = () => {
  const error = useRouteError();
  if (error) {
    Sentry.captureException(error);
  }
  return <div>Something went wrong</div>;
};

export default function App() {
  return <Outlet />;
}
